import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { DEAL_CHECKER_CREATIVE_ID } from 'site-modules/lease-deals/components/deals-checker-widget/constants';
import { DealChecker } from './components/deal-checker/deal-checker';

import './deal-checker-widget.scss';

export function DealCheckerWidget({ className = null }) {
  return (
    <div
      id="lease-deals-deal-checker"
      className={classnames('deal-checker-widget mx-auto', className)}
      data-tracking-parent={DEAL_CHECKER_CREATIVE_ID}
    >
      <h2 className="size-30 text-center">How good is your lease deal?</h2>
      <div className="text-center text-cool-gray-30 size-16 mb-1_5">
        Got a lease offer from a dealer? Tell us the details and we’ll tell you if it’s worth it.
      </div>
      <DealChecker />
    </div>
  );
}

DealCheckerWidget.propTypes = { className: PropTypes.string };
